import marked from 'marked';
export const markdownToHtml = (markdown) => {
    if (!markdown) {
        return '';
    }
    const opts = {
        pedantic: false,
        gfm: true,
        tables: true,
        breaks: true,
        sanitize: false,
        smartLists: true,
        smartypants: true,
        xhtml: true
    };
    return marked(markdown, opts);
};
